import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
import AddPaymentMode from "./AddPaymentMode";
import EditPaymentMode from "./EditPaymentMode";
import DeletePaymentMode from "./DeletePaymentMode";
import PaymentModeViewModel from "../PaymentMode/PaymentModeViewModel";
import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");
class PaymentMode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showpaymodeAddModel: false,
      showpaymodeEditModel: false,
      showpaymodeDelModel: false,
      PaymentmodeViewShow: false,
      page: 0,
      perPage: 10,
    };
  }
  componentDidMount() {
    this.props.paymentmodelist();
    // console.log(this.props.PaymentmodeList);
  }
  handleAddPaymentMode = () => {
    this.setState({
      showpaymodeAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showpaymodeAddModel: false,
    });
  };
  handleEditPaymentMode = (item) => {
    this.setState({
      showpaymodeEditModel: true,
      ItemList: item,
    });
  };
  closeEditModel = () => {
    this.setState({
      showpaymodeEditModel: false,
    });
  };
  handleDelPaymentMode = (item) => {
    this.setState({
      showpaymodeDelModel: true,
      DeletepaymodeItem: item,
    });
  };
  closepaymodeDelModel = () => {
    this.setState({
      showpaymodeDelModel: false,
    });
  };
  handlePaymentmodeView = (item) => {
    this.setState({
      PaymentmodeViewShow: true,
      PaymentmodeDtls: item,
    });
  };

  handleClosePaymentmode = () => {
    this.setState({ PaymentmodeViewShow: false });
  };
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.paymentmodeSlectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };
  render() {
    let p = this.state.page + 1;
    const count = this.props.PaymentmodeCount && this.props.PaymentmodeCount;
    let paymentmodePageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Payment Mode</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddPaymentMode()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddPaymentMode
                showpaymodeAddModel={this.state.showpaymodeAddModel}
                closeAddModel={this.closeAddModel}
                AddPaymentMode={this.props.AddPaymentMode}
                resetPage={this.resetPage}
              />
            </div>
            <div>
              <Table responsive className="cmnMainTable" bordered striped>
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>NAME</th>
                    <th>Description</th>
                    <th>ACTIVE</th>
                    <th>CREATED DATE</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.PaymentmodeList &&
                    this.props.PaymentmodeList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.name}
                        </td>
                        <td className="cmn_Cap commonDesc">
                          {item !== null && item.disc}
                        </td>

                        <td>{item !== null && item.isActive ? "Yes" : "No"}</td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handlePaymentmodeView({
                                  item: item,
                                })
                              }
                            ></i>
                            <PaymentModeViewModel
                              show={this.state.PaymentmodeViewShow}
                              handleClose={this.handleClosePaymentmode}
                              PaymentmodeDtls={this.state.PaymentmodeDtls}
                            />
                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleEditPaymentMode(item)}
                            ></i>
                            <EditPaymentMode
                              showpaymodeEditModel={
                                this.state.showpaymodeEditModel
                              }
                              closeEditModel={this.closeEditModel}
                              ItemList={this.state.ItemList}
                              EditPaymentMode={this.props.EditPaymentMode}
                              resetPage={this.resetPage}
                            />

                            <i
                              className="fa fa-trash fa-lg"
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleDelPaymentMode(item)}
                            ></i>
                            <DeletePaymentMode
                              showpaymodeDelModel={
                                this.state.showpaymodeDelModel
                              }
                              closepaymodeDelModel={this.closepaymodeDelModel}
                              DeletepaymodeItem={this.state.DeletepaymodeItem}
                              DeletePaymentMode={this.props.DeletePaymentMode}
                              resetPage={this.resetPage}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {(this.props.PaymentmodeList === undefined ||
                (this.props.PaymentmodeList &&
                  this.props.PaymentmodeList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Paymentmodes Found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {paymentmodePageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={paymentmodePageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default PaymentMode;
